var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"beat-progress"}},[_c('beat-loader',{attrs:{"loading":_vm.loading,"width":_vm.width,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }